export default "__VITE_ASSET__DY9_DXP5__"